import React, { createContext, useContext, useState, useEffect } from 'react';

const AUTH_VERSION = '2';
const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authToken, setAuthToken] = useState(() => sessionStorage.getItem('token') || '');
  const [tipoUsuario, setTipoUsuario] = useState(() => localStorage.getItem('tipoUsuario') || '');
  const [nombreUsuario, setnombreUsuario] = useState(() => localStorage.getItem('nombreUsuario') || '');

  useEffect(() => {
    // Limpieza automática SIEMPRE al refrescar la página
    localStorage.clear();
    sessionStorage.clear();
    setAuthToken('');
    setTipoUsuario('');
    setnombreUsuario('');
  }, []);


  useEffect(() => {
    // Este efecto se ejecuta cada vez que cambian las variables de estado authToken, tipoUsuario o usuarioAutenticado
    console.log('Autenticación correcta:', authToken, tipoUsuario, nombreUsuario);
  }, [authToken, tipoUsuario, nombreUsuario]);

  function handleAuthenticationSuccess(data) {
    console.log('🔐 Guardando autenticación:', data);

    setAuthToken(data.token);
    setTipoUsuario(data.tipoUsuario);
    setnombreUsuario(data.nombreUsuario);

    // Guardar token en sessionStorage (se borra al cerrar pestaña), resto en localStorage
    if (data.token) {
      sessionStorage.setItem('token', data.token);
      console.log('✅ Token guardado en sessionStorage');
    }

    if (data.tipoUsuario) {
      // Ya se guarda en Login.jsx pero lo reforzamos aquí
      localStorage.setItem('tipoUsuario', data.tipoUsuario);
      console.log('✅ TipoUsuario guardado:', data.tipoUsuario);
    }

    if (data.nombreUsuario) {
      console.log('✅ Nombre de usuario asignado:', data.nombreUsuario);
    }
  }

  const iniciarSesion = (tipo, usuario) => {
    setTipoUsuario(tipo);
    setnombreUsuario(usuario);
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken,
        tipoUsuario,
        iniciarSesion,
        setTipoUsuario,
        nombreUsuario,
        setnombreUsuario,
        handleAuthenticationSuccess,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
